// ProductDetails.js
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import "./ProductDetails.css";
import RelatedProduct from "../RelatedProduct/RelatedProduct";
import Reviews from "../Reviews/Reviews";
import NavBar from "../../components/NavBar/NavBar";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Swal from "sweetalert2";
import Loaderdots from "../../components/LoaderDots/Loaderdots";
import NoData from "../../components/NoData/NoData";
import { FaStar } from "react-icons/fa6";


// import toast from "react-hot-toast";
import { toast } from "react-toastify";
import { BeatLoader } from "react-spinners";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FaFacebookF, FaTwitter, FaWhatsapp, FaPinterestP, FaLink } from 'react-icons/fa';
import { BsArrowLeft, BsArrowRight } from 'react-icons/bs';
import SizeGuid from "../SideGuide/SizeGuid";

function ProductDetails() {
  const { id } = useParams();

  const [product, setProduct] = useState(null);
  const [relatedProducts, setRelatedProduct] = useState([]);
  const [error, setError] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedSize, setSelectedSize] = useState("");
  const [isDisable, setDisable] = useState(false);
  const [selectedColor, setColor] = useState("");

  const token = localStorage.getItem("userToken");
  const navigate = useNavigate();

  const [stockStatusMessage, setStockStatusMessage] = useState(""); // New state for stock status message

  const [reviews, setReviews] = useState([]);
  const [averageRating, setAverageRating] = useState(5);
  const [loading, setLoading] = useState(true);

  // share functionality starts here
  const [isShareOpen, setIsShareOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const shareUrl = window.location.href;
  const shareTitle = product?.name || "Check out this product!";
  const shareImage = product?.images[0]?.url 
    ? `https://riymay.com/assets/${product.images[0].url}` 
    : '';

  // Social media share functions
  const shareToFacebook = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
      "facebook-share-dialog",
      "width=626,height=436"
    );
    setIsShareOpen(false);
  };

  const shareToTwitter = () => {
    window.open(
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareTitle)}`,
      "twitter-share-dialog",
      "width=626,height=436"
    );
    setIsShareOpen(false);
  };

  const shareToWhatsApp = () => {
    window.open(
      `https://api.whatsapp.com/send?text=${encodeURIComponent(`${shareTitle} ${shareUrl}`)}`,
      "whatsapp-share-dialog",
      "width=626,height=436"
    );
    setIsShareOpen(false);
  };

  const shareToPinterest = () => {
    window.open(
      `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(shareUrl)}&media=${encodeURIComponent(shareImage)}&description=${encodeURIComponent(shareTitle)}`,
      "pinterest-share-dialog",
      "width=626,height=436"
    );
    setIsShareOpen(false);
  };

  // share functionality ends here


  useEffect(() => {
    // Fetch reviews from the API
    fetch(`https://riymay.com/api/v1/user/products/${id}/reviews`)
      .then((response) => response.json())
      .then((data) => {
        const fetchedReviews = data.productReviewRating || [];
        setReviews(fetchedReviews);

        // Calculate average rating
        const totalRatings = fetchedReviews.reduce(
          (acc, review) => acc + review.rating,
          0
        );
        const avgRating = fetchedReviews.length
          ? totalRatings / fetchedReviews.length
          : 0;

        setAverageRating(avgRating.toFixed(1));
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching reviews:", error);
        setLoading(false);
      });
  }, []);

  // Function to check stock status
  const checkStockStatus = (size, color) => {
    if (!size || !color) {
      setStockStatusMessage("");
      return;
    }


    const matchingStock = product.stock.find(
      (stockItem) => stockItem.size === size && stockItem.color === color
    );

    if (!matchingStock || matchingStock.stockStatus !== "inStock") {
      setStockStatusMessage("Out of Stock");
    } else if (parseInt(matchingStock.quantity, 10) === 0) {
      setStockStatusMessage("Out of Stock (Quantity: 0)");
    } else {
      setStockStatusMessage("In Stock");
    }
  };

  // Update stock status when size or color changes
  useEffect(() => {
    checkStockStatus(selectedSize, selectedColor);
  }, [selectedSize, selectedColor]);



  const handleSizeChart = () => {
    console.log(id, "product id 128++++++++++")
    navigate("/size-guide",{ state: { id: id} })
  }

  useEffect(() => {
    // Fetch product details by ID from route parameter
    fetch(`https://riymay.com/api/v1/user/products/product?id=${id}`)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch product");
        }
        return res.json();
      })
      .then((data) => {
        setProduct(data.product);
        setRelatedProduct(data.relatedProducts);
        setSelectedImage(data.product.images[0] || "");
      })
      .catch((err) => setError(err.message));
  }, [id]);

  // Handle add to cart
  // const handleAddToCart = async (id) => {
  //   const token = localStorage.getItem("userToken");

  //   if (!token) {
  //     toast.error("Please Login to your account", {
  //       position: "top-right",
  //       autoClose: 3000, // Auto close after 3 seconds
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       // theme: "colored",
  //       className: "custom-toast",
  //       bodyClassName: "custom-toast-body",
  //     });
  //      navigate("/login");
  //   }
  //   if (!selectedSize) {
  //     toast.warning("Please select a size before adding to cart.", {
  //       position: "top-right",
  //       autoClose: 3000, // Closes after 3 seconds
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       // theme: "colored",
  //       className: "custom-toast",
  //       bodyClassName: "custom-toast-body",
  //     });      return;
  //   }
  //   if (!selectedColor) {
  //     toast.warning("Please select a color before adding to cart.", {
  //       position: "top-right",
  //       autoClose: 3000, // Closes after 3 seconds
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       className: "custom-toast",
  //       bodyClassName: "custom-toast-body",
  //     });      return;
  //   }

  //   // Check stock for selected size and color
  //   const matchingStock = product.stock.find(
  //     (stockItem) =>
  //       stockItem.size === selectedSize &&
  //       stockItem.color === selectedColor &&
  //       stockItem.stockStatus === "inStock"
  //   );

  //   if (!matchingStock) {
  //     toast.error(`The selected size (${selectedSize}) and color (${selectedColor}) is out of stock.`, {
  //       position: "top-right",
  //       autoClose: 4000, // Closes after 4 seconds
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       // theme: "colored",
  //       className: "custom-toast",
  //       bodyClassName: "custom-toast-body",
  //     });
  //     return;
  //   }

  //   if (parseInt(matchingStock.quantity, 10) === 0) {
  //     toast.error(`The selected size (${selectedSize}) and color (${selectedColor}) is out of stock (quantity is 0).`, {
  //       position: "top-right",
  //       autoClose: 4000, // Closes after 4 seconds
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       // theme: "colored",
  //       className: "custom-toast",
  //       bodyClassName: "custom-toast-body",
  //     });

  //     return;
  //   }

  //   // Add to cart logic
  //   const data = {
  //     size: selectedSize,
  //     color: selectedColor,
  //     productId: id,
  //   };

  //   const makeAPI = await fetch(`https://riymay.com/api/v1/user/cart`, {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `Bearer ${token}`,
  //     },
  //     body: JSON.stringify(data),
  //   });
  //   const responseAPI = await makeAPI.json();
  //   if( responseAPI.message === "email is not verfied"){

  //     try {
  //       const token = localStorage.getItem("userToken")
  //       // Call the resend OTP API
  //       const resendResponse = await fetch("https://riymay.com/api/v1/user/resend/verification/email", {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //         body: JSON.stringify({token}),
  //       });

  //       const resendData = await resendResponse.json();
  //       if (resendData.message) {
  //         navigate("/otp-verification",{ state: { email: resendData.email} });
  //       } else {
  //         setError(resendData.message || "Failed to resend OTP");
  //         toast.error(resendData.message || "Failed to resend OTP", {
  //           containerId: "custom-toast-container",
  //           position: "top-right",
  //           autoClose: 3000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //           theme: "colored",
  //           className: "custom-toast",
  //           bodyClassName: "custom-toast-body",
  //         });
  //       }
  //     } catch (error) {
  //       setError("An error occurred while resending OTP");
  //       toast.error("An error occurred while resending OTP", {
  //         containerId: "custom-toast-container",
  //         position: "top-right",
  //         autoClose: 3000,
  //         hideProgressBar: false,
  //         closeOnClick: true,
  //         pauseOnHover: true,
  //         draggable: true,
  //         theme: "colored",
  //         className: "custom-toast",
  //         bodyClassName: "custom-toast-body",
  //       });

  //     }
  //   }
  //   else if (responseAPI.message === "Invalid token") {
  //     toast.info("Session Timeout", {
  //       position: "top-right",
  //       autoClose: false, // Stays until user clicks
  //       closeOnClick: true,
  //       draggable: true,
  //       className: "custom-toast",
  //       bodyClassName: "custom-toast-body",
  //     });

  //     localStorage.removeItem("userToken");
  //     navigate("/login");
  //     return;
  //   }

  //   toast.success(`Added ${product.name.slice(0, 20)} to cart.`, {
  //     position: "top-right",
  //     autoClose: 3000, // Close after 3 seconds
  //     hideProgressBar: false,
  //     closeOnClick: true,
  //     pauseOnHover: true,
  //     draggable: true,
  //     theme: "colored",
  //     className: "custom-toast",
  //     onClose: () => {
  //       navigate("/cart"); // Navigate after toast closes
  //     },
  //   });

  //   setDisable(true);
  // }

  const handleAddToCart = async (id) => {
    if (loading || isDisable) return; // Prevent multiple clicks

    const token = localStorage.getItem("userToken");

    if (!token) {
      toast.error("Please Login to your account", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        className: "custom-toast",
        bodyClassName: "custom-toast-body",
      });
      navigate("/login");
      return;
    }

    if (!selectedSize) {
      toast.warning("Please Select a Size & Color Before Adding to Cart.", {
        toastId: "CArtSize",
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        // className: "custom-toast",
        bodyClassName: "custom-toast-body",
        theme: "colored",
        rtl: false,
      });
      return;
    }

    if (!selectedColor) {
      toast.warning("Please Select a Size & Color Before Adding to Cart.", {
        position: "top-right",
        toastId: "CArtSize",

        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        // className: "custom-toast",
        bodyClassName: "custom-toast-body",
        theme: "colored",
        rtl: false,
      });

      return;
    }

    // Check stock for selected size and color
    const matchingStock = product.stock.find(
      (stockItem) =>
        stockItem.size === selectedSize &&
        stockItem.color === selectedColor &&
        stockItem.stockStatus === "inStock"
    );

    if (!matchingStock || parseInt(matchingStock.quantity, 10) === 0) {
      toast.error(
        `The selected size (${selectedSize}) and color (${selectedColor}) is out of stock.`,
        {
          toastId: "utOfStack",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          className: "custom-toast",
          bodyClassName: "custom-toast-body",
          theme: "colored",
          rtl: false,
        }
      );
      return;
    }

    // Add to cart logic
    const data = {
      size: selectedSize,
      color: selectedColor,
      productId: id,
    };

    try {
      const makeAPI = await fetch("https://riymay.com/api/v1/user/cart", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      });

      const responseAPI = await makeAPI.json();

      if (responseAPI.message === "email is not verfied") {
        try {
          const resendResponse = await fetch(
            "https://riymay.com/api/v1/user/resend/verification/email",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({ token }),
            }
          );

          const resendData = await resendResponse.json();
          if (resendData.email) {
            navigate("/otp-verification", {
              state: { email: resendData.email },
            });
          } else {
            toast.error(resendData.message || "Failed to resend OTP", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              className: "custom-toast",
              bodyClassName: "custom-toast-body",
            });
          }
        } catch (error) {
          toast.error("An error occurred while resending OTP", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            className: "custom-toast",
            bodyClassName: "custom-toast-body",
          });
        }
        return;
      }

      if (responseAPI.message === "Invalid token") {
        toast.info("Session Timeout", {
          position: "top-right",
          autoClose: false,
          closeOnClick: true,
          draggable: true,
          className: "custom-toast",
          bodyClassName: "custom-toast-body",
        });

        localStorage.removeItem("userToken");
        navigate("/login");
        return;
      }
      localStorage.removeItem(`coupon_${id}_${selectedSize}`);
      toast.success(`Added ${product.name.slice(0, 20)} to cart.`, {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        className: "custom-toast",
        bodyClassName: "custom-toast-body",
        toastId: "addedToCart",
        onClose: () => {
          if (!window.location.pathname.includes("/cart")) {
            // ✅ Ensures navigation happens only if the user is NOT already on the cart page
            navigate("/cart");
          }
        },
      });

      setDisable(true);
    } catch (error) {
      toast.error("An unexpected error occurred.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        className: "custom-toast",
        bodyClassName: "custom-toast-body",
      });
    }
  };

  if (loading) return <Loaderdots />;

  if (error) return <NoData />;
  if (!product)
    return (
      <div className="loader-container">
        <div className="traffic-loader"></div>
      </div>
    );

  const settings = {
    dots: true, // Show navigation dots below the carousel
    arrows: false, // Show next/prev arrows
    infinite: true, // Infinite looping of slides
    speed: 500, // Transition speed (in milliseconds)
    slidesToShow: 1, // Number of slides to show at a time
    slidesToScroll: 1, // Number of slides to scroll at a time
    autoplay: true, // Auto-scroll slides
    autoplaySpeed: 3000, // Speed for auto-scrolling (in milliseconds)
    cssEase: "ease", // CSS transition timing function
    adaptiveHeight: true, // Adjust slide height to fit content
    initialSlide: 0, // Starting slide index
    pauseOnHover: false,
  };

  const handleSizeGuideClick = () => {
    Swal.fire({
      title: "Size Guide 📏",
      html: <SizeGuid />,
      showConfirmButton: false,
      width: 350,
      heightAuto: false,
      customClass: {
        popup: "custom-swal-popup",
      },
      position: "center",
    });
  };

  return (
    <>
      <div className="product-details-container">
        <div className="product-details-left">
          <Slider
            {...settings}
            className="product-details-images-carousel custom-slider"
          >
            {product.images.map((image, index) => (
              <img
                key={index}
                src={`https://riymay.com/assets/${image.url}`}
                alt={`Thumbnail ${index + 1}`}
                className={`carousel-image ${
                  selectedImage === image ? "selected" : ""
                }`}
                onClick={() => setSelectedImage(image)}
              />
            ))}
          </Slider>
        </div>

        <div className="product-details-right">
          <h2>{product.name.slice(0, 20)}</h2>
          <div className="review-info">
            {/* <span className="review-user">{review.userName}</span> */}
            {/* <span className="review-rating">
              {Array.from({ length: 5 }, (_, i) => (
                <span
                  key={i}
                  className={`i <averageRating} ? "star filled" : "star"`}
                >
                  ★
                </span>
              ))}{" "}
              <span>({reviews.length})</span>
            </span> */}



            <span className="review-rating">
                      {Array.from({ length: 5 }, (_, i) => (
                        <span
                          key={i}
                          className={i < averageRating ? "star filled" : "star"}
                        >
                          <FaStar style={{fontSize:"1rem"}}/>


                        </span>
                      ))}{" "}
                    </span>          {" "}    <span>({reviews.length})</span>

          </div>

          <h3>{product.category}</h3>
          {/* <button className="size-guide-1" onClick={handleSizeGuideClick}>
        Size Guide 📏 
      </button> */}
          <h3>₹ {product.price}</h3>

          {/* <p>U.S. SIZING - SEE SIZE CHART FOR CONVERSION.</p> */}

          <div className="price-section">
            {/* <button className="select-size-button">SELECT SIZE - $130.00</button> */}
            {/* <p>OR 4 INTEREST-FREE PAYMENTS OF $32.50 WITH AFTERPAY</p> */}
          </div>

          <div className="product-details-stock-1">
            <p>Select Size</p>
            <div className="product-details-sizes-1">
              {product.availableSizes.map((stockSize) => (
                <button
                  key={stockSize}
                  className={`product-details-size-1 ${
                    selectedSize === stockSize
                      ? "product-details-size-selected-1"
                      : ""
                  }`}
                  onClick={() => setSelectedSize(stockSize)}
                  // disabled={stockItem.stockStatus !== "inStock"}
                >
                  {stockSize}
                </button>
              ))}
            </div>

            <div className="product-details-colors">
              <p>Select Color:</p>
              <div className="product-details-colors-stockstatus">
                {product.availableColors.map((color, index) => (
                  <span
                    key={index}
                    onClick={() => setColor(color)}
                    // disabled={stockItem.stockStatus !== "inStock"}
                    className={`product-details-color ${
                      selectedColor === color ? "highlight" : "unhighlight"
                    }`}
                    style={{
                      backgroundColor: color,
                      border:
                        selectedColor === color
                          ? "3px solid black"
                          : "1px solid gray",
                    }}
                  ></span>
                ))}
              </div>
            </div>
            <p
              className={`stock-status-message ${
                stockStatusMessage === "In Stock" ? "in-stock" : "out-of-stock"
              }`}
            >
              {stockStatusMessage}{" "}
              {stockStatusMessage === "In Stock" ? (
                <button className="size-guide-1" 
                // onClick={handleSizeGuideClick}>
                onClick={handleSizeChart}
                >
                  Size Guide 📏
                </button>
              ) : (
                ""
              )}
            </p>
            




            <button
              className={`product-details-add-to-cart ${
                stockStatusMessage === "In Stock"
                  ? "active-cart"
                  : "disabled-car"
              }`}
              onClick={() => handleAddToCart(product._id)}
              // disabled={isDisable || stockStatusMessage !== "In Stock"}
            >
              {isDisable ? <BeatLoader size={8} color="#fff" /> : "Add to Cart"}
            </button>
           {/*Share Section */}
          <div className="share-container">
            <button 
              className="share-button"
              onClick={() => setIsShareOpen(!isShareOpen)}
            >
              <FaLink size={16} /> Share
            </button>

            {isShareOpen && (
              <div className="share-options">
                <button 
                  className="share-option facebook"
                  onClick={shareToFacebook}
                >
                  <FaFacebookF size={18} />
                  <span>Facebook</span>
                </button>
                
                <button 
                  className="share-option twitter"
                  onClick={shareToTwitter}
                >
                  <FaTwitter size={18} />
                  <span>Twitter</span>
                </button>
                
                <button 
                  className="share-option whatsapp"
                  onClick={shareToWhatsApp}
                >
                  <FaWhatsapp size={18} />
                  <span>WhatsApp</span>
                </button>
                
                <button 
                  className="share-option pinterest"
                  onClick={shareToPinterest}
                >
                  <FaPinterestP size={18} />
                  <span>Pinterest</span>
                </button>
                
                <CopyToClipboard 
                  text={shareUrl}
                  onCopy={() => {
                    setCopied(true);
                    setTimeout(() => {
                      setCopied(false);
                      setIsShareOpen(false);
                    }, 1500);
                  }}
                >
                  <button className="share-option copy">
                    <FaLink size={18} />
                    <span>{copied ? "Copied!" : "Copy Link"}</span>
                  </button>
                </CopyToClipboard>
              </div>
            )}
          </div>
          </div>
          <div className="product-details-stock-1">
            <p>Description</p>
            <span className="description-product-details">
              {product.description}
            </span>
          </div>
        </div>
      </div>

      <div className="product-details-related">
        <h2>Related Products</h2>
        <div className="product-details-related-items">
          {relatedProducts.length != 0 ? (
            relatedProducts.map((product) => (
              <Link
                className="related-product-container"
                key={product._id}
                to={`/product/${product._id}`}
              >
                <RelatedProduct key={product._id} product={product} />
              </Link>
            ))
          ) : (
            <>
              {relatedProducts.length > 0 ? <Loaderdots /> : " No Data Found"}
            </>

            // <Loaderdots />
            // <NoData />
          )}
        </div>
      </div>

      <div className="product-details-show-reviews-container">
        <div className="product-details-show-reviews">
          <h2 className="product-details-show-reviews-heading">
            Ratings & Reviews
          </h2>
        </div>

        <Reviews productId={id} reviews={reviews} />
      </div>
      {/* </div> */}
    </>
  );
}

export default ProductDetails;
